// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2VIH1","productName":"Table_productName__2Q4TH"};